import React from 'react';
import './ProductionSubpage.css';

const SodanJaljet = () => {
  return (
    <div className="production-subpage-container">
      <h1>Sodan jäljet</h1>
      <i>Sivusto työn alla</i>
    </div>
  );
};

export default SodanJaljet;